<template>

	<LoaderOverlay :active="isLoading" />

	<div v-if="!isLoading">
		<BaseAccount
			v-if="appointments.length"
			:title="$t('Past Appointments')"
			:appointments="appointments"
		>
			<template v-slot:doctorSlot="doctorProps">
        <DoctorComponent
          :doctor="doctorProps.doctor"
          :showServiceTime="true"
          :showPersonalizedService="false"
          :showMapButton="hasMapLocation(doctorProps.doctor)"
          :show-doctor-reviews="false"
          :show-payment-method="false"
          :showReviewButton="false"
          @view-map="openMapModal"
          @review-appointment="openReviewModal"
        />
			</template>

		</BaseAccount>

		<AccountEmptyState
			v-else
			:title="$t('Past Appointments')"
			:message="$t('No results found')"
			:description="$t('Your past appointments will appear here once they are completed.')"
			:button-label="$t('Find a specialist')"
			:button-to="'/search'"
		>
			<template #icon>
				<IconClock :size="32" />
			</template>
		</AccountEmptyState>
	</div>

  <ReviewPopup
    v-if="isReviewModalVisible"
    id="reviewPopup"
    :doctor="selectedDoctor"
    @close="closeCancelModal"
  />

  <MapModal
    v-if="isMapModalVisible"
    :doctors="mapDoctors"
    :map-only="true"
    @close="closeMapModal"
  />
</template>

<script>

import { defineComponent } from "vue";
import DoctorComponent from '@/components/doctor/doctorComponent.vue';
import ReviewPopup from '@/components/doctor/reviewPopup.vue';
import BaseAccount from '@/components/account/baseAccount.vue';
import AccountEmptyState from '@/components/account/AccountEmptyState.vue';
import IconClock from '@/components/icons/IconClock.vue';
import MapModal from '@/components/search/mapModal.vue';
import LoaderOverlay from '@/components/loader/loader.vue';
import CustomerHelper from '@/helpers/customerHelper';
import { customerBookings } from '@/services/naaviApi/internalService';
import { mapCustomerBookingsToAppointments } from '@/helpers/customerBookingsMapper';

export default defineComponent({
  name: "PastAppointmentsView",
  components: {
    DoctorComponent,
    ReviewPopup,
    MapModal,
    BaseAccount,
    AccountEmptyState,
    IconClock,
    LoaderOverlay
  },
  data() {
    return {
      isReviewModalVisible: false,
      appointments: [],
      selectedDoctor: null,
      isMapModalVisible: false,
      mapDoctors: [],
      isLoading: false,
    }
  },
	mounted() {
		this.loadAppointments();
	},
  methods: {
    hasMapLocation(doctor) {
      return Boolean(doctor && doctor.position && doctor.position.lat != null && doctor.position.lng != null);
    },
    openReviewModal(doctor) {
      this.selectedDoctor = doctor;
      this.isReviewModalVisible = true;
    },
    closeCancelModal() {
      this.isReviewModalVisible = false;
    },
    openMapModal(doctor) {
      if (!doctor) {
        this.mapDoctors = [];
        this.isMapModalVisible = false;
        return;
      }
      this.mapDoctors = [doctor];
      this.isMapModalVisible = true;
    },
    closeMapModal() {
      this.isMapModalVisible = false;
      this.mapDoctors = [];
    },
    async loadAppointments() {
      const user = CustomerHelper.getUser();

      if (!user) {
        this.appointments = [];
        return;
      }

      this.isLoading = true;

      try {
        const response = await customerBookings();
        const past = response && response.past ? response.past : [];
        this.appointments = mapCustomerBookingsToAppointments(past);
      } catch (error) {
        this.appointments = [];
      } finally {
        this.isLoading = false;
      }
    }
  }
});
</script>
